import styled from "styled-components";
import { deviceSpec } from "breakpoints";

// Styled Components
export const CarouselContainer = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  justify-content: center;

  .wave {
    position: relative;
    text-align: center;
    margin-left: auto;
    margin-right: auto;

    .dot {
      color: ${({theme}) => theme.colors.textColor};
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 3px;
      background: white;
      animation: wave 1.3s linear infinite;

      &:nth-child(2) {
        animation-delay: -1.1s;
      }

      &:nth-child(3) {
        animation-delay: -0.9s;
      }
    }
  }

  @keyframes wave {
    0%,
    60%,
    100% {
      transform: initial;
    }

    30% {
      transform: translateY(-10px);
    }
  }

  @media ${deviceSpec.isTablet} {
    padding-bottom: 5rem;

    pre {
      margin-top: 1rem;
    }
  }

  @media ${deviceSpec.isTablet} {
    .markdown pre {
      margin-top: 1rem;
    }
  }
`;

export const CarouselWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const CarouselImagesOuterContainer = styled.div`
  border-radius: 24px;
  overflow: hidden;
  border: 2px rgba(0, 0, 0, 0.125) solid;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`;

export const CarouselImagesContainer = styled.div`
  display: flex;
  transition: transform 1s ease;
`;

export const CarouselImage = styled.div`
  min-width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Dot = styled.span`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  cursor: pointer;

  @media ${deviceSpec.isMobile} {
    height: 1.25rem;
    width: 1.25rem;
    margin: 0.75rem;
  }
`;
